var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWorldMusic = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Instrument-Maracas-1--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Instrument Maracas 1 Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10 9.69a0.25 0.25 0 0 1 0 -0.26 5 5 0 0 0 -1.21 -5.22L8.61 4a0.26 0.26 0 0 0 -0.28 0 0.24 0.24 0 0 0 -0.14 0.24l0.22 2.36a1.24 1.24 0 0 1 -1.57 1.33l-1.51 -0.41a0.26 0.26 0 0 0 -0.25 0.07 0.26 0.26 0 0 0 -0.08 0.24l0.41 1.51a1.25 1.25 0 0 1 -0.24 1.13 1.29 1.29 0 0 1 -1 0.45l-2.48 -0.23a0.24 0.24 0 0 0 -0.24 0.14 0.26 0.26 0 0 0 0 0.28l0.17 0.18a5 5 0 0 0 5.22 1.17 0.25 0.25 0 0 1 0.26 0.06l0.74 0.74a0.27 0.27 0 0 0 0.18 0.08 0.25 0.25 0 0 0 0.18 -0.08l2.47 -2.47a0.25 0.25 0 0 0 0 -0.36Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.34 20.66a2 2 0 0 0 2.82 -2.82l-2.09 -2.1a0.25 0.25 0 0 0 -0.36 0l-2.47 2.47a0.25 0.25 0 0 0 0 0.36Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.34 7.38a1.26 1.26 0 0 1 1.54 -1.54l1.66 0.46a0.25 0.25 0 0 0 0.22 0 0.27 0.27 0 0 0 0.09 -0.3l-0.27 -2.9a0.24 0.24 0 0 0 -0.2 -0.22 5 5 0 0 0 -6 6 0.24 0.24 0 0 0 0.22 0.2l2.93 0.27a0.25 0.25 0 0 0 0.22 -0.09A0.25 0.25 0 0 0 3.8 9Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.92 13.41a0.27 0.27 0 0 0 0.08 -0.21 0.26 0.26 0 0 0 -0.13 -0.19 6 6 0 0 1 -1.35 -1 5.92 5.92 0 0 1 -1 -1.35 0.26 0.26 0 0 0 -0.19 -0.13 0.25 0.25 0 0 0 -0.21 0.07l-7.28 7.24a2 2 0 0 0 2.82 2.82Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.29 4.21a5 5 0 0 0 -3.54 -1.46 4.78 4.78 0 0 0 -1.13 0.13 0.24 0.24 0 0 0 -0.2 0.22L17.15 6a0.27 0.27 0 0 0 0.09 0.22 0.25 0.25 0 0 0 0.22 0l1.66 -0.46a1.26 1.26 0 0 1 1.54 1.54L20.2 9a0.25 0.25 0 0 0 0.27 0.31l2.93 -0.27a0.24 0.24 0 0 0 0.22 -0.2 5 5 0 0 0 -1.33 -4.63Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.78 10.92a1.28 1.28 0 0 1 -1 -0.45 1.25 1.25 0 0 1 -0.24 -1.13L19 7.83a0.26 0.26 0 0 0 -0.06 -0.24 0.26 0.26 0 0 0 -0.25 -0.07l-1.51 0.41a1.24 1.24 0 0 1 -1.57 -1.31l0.22 -2.37a0.26 0.26 0 0 0 -0.44 -0.25l-0.18 0.17a5 5 0 0 0 7.08 7.08l0.17 -0.18a0.26 0.26 0 0 0 0 -0.28 0.24 0.24 0 0 0 -0.24 -0.14Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWorldMusic);
export default ForwardRef;